var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l(([{name: _vm.$t('library.library'), id: null}, ..._vm.route]),function(r){return _c('span',{key:r.id},[_c('v-chip',{attrs:{"lg":""},on:{"click":function($event){return _vm.handleClick(r)}}},[_vm._v(" "+_vm._s(r.name)+" ")]),_c('v-icon',[_vm._v(" mdi-chevron-right ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }